// extracted by mini-css-extract-plugin
export default {"thresholdTextField":"NewCommentersConfigContainer-thresholdTextField-0c01f72385456def5b68553d15da01fb"};